import makeApiRequest from './makeApiRequest';

const getSession = () => {
	const getApiRequest = makeApiRequest('GET');

	const acquireSession = async (apiBase: string) => getApiRequest(`${apiBase}/api/session`, {});

	return [acquireSession];
};

export default getSession;
